import pl from "@locales/program_preview/pl.json";
import en from "@locales/program_preview/en.json";

export default {
  pl: pl,
  en: en,
};
